export const ZOOM_IN = 'ZOOM_IN';
export const ZOOM_OUT = 'ZOOM_OUT';
export const ZOOM_PAN_MOVED = 'ZOOM_PAN_MOVED';
export const ZOOM_SET_PAN_BY = 'ZOOM_SET_PAN_BY';
export const ZOOM_UPDATE = 'ZOOM_UPDATE';
export const ZOOM_RESET = 'ZOOM_RESET';
